import * as React from 'react';
const SvgClose = () =>
  /* @__PURE__ */ React.createElement(
    'svg',
    { width: 18, height: 18, fill: 'none' },
    /* @__PURE__ */ React.createElement('path', {
      fill: 'currentColor',
      fillRule: 'evenodd',
      d: 'M15.759 2.241a.824.824 0 0 1 0 1.165L3.406 15.759a.824.824 0 1 1-1.165-1.165L14.594 2.241a.824.824 0 0 1 1.165 0',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fill: 'currentColor',
      fillRule: 'evenodd',
      d: 'M2.241 2.241a.824.824 0 0 1 1.165 0l12.353 12.353a.824.824 0 0 1-1.165 1.165L2.241 3.406a.824.824 0 0 1 0-1.165',
      clipRule: 'evenodd',
    }),
  );
export default SvgClose;
